import { ApiResult } from './core';
import { setToken, clearToken } from '../../utils/auth';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.lens.aivilo.ai/core/api/v1';

export const authAPI = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Returns dynamic user object from API
  login: async (email: string, password: string): Promise<{ success: boolean; error?: string; user?: any }> => {
    try {
      const response = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({})) as { detail?: string; message?: string };
        // FastAPI uses 'detail' for error messages
        const errorMessage = errorData.detail || errorData.message || 'Incorrect email or password';
        console.error('Login failed:', errorMessage);
        return { success: false, error: errorMessage };
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const data = await response.json() as { token: string; user: any };

      // Store token and user data
      setToken(data.token);
      localStorage.setItem('user', JSON.stringify(data.user));

      return { success: true, user: data.user };
    } catch (error) {
      console.error('Login error:', error);
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message || 'An error occurred during login' };
    }
  },

  logout: async (): Promise<{ success: boolean }> => {
    localStorage.removeItem('user');
    clearToken();
    localStorage.removeItem('anonymous_session_token');
    localStorage.removeItem('anonymous_session_client_id');
    localStorage.removeItem('anonymous_session_expires_at');
    return { success: true };
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Returns parsed JSON user object
  getCurrentUser: (): any => {
    const user = localStorage.getItem('user');
    // Handle cases where localStorage has "undefined" as a string
    if (!user || user === 'undefined' || user === 'null') {
      return null;
    }
    try {
      return JSON.parse(user);
    } catch (error) {
      console.error('Failed to parse user from localStorage:', error);
      // Clear invalid user data
      localStorage.removeItem('user');
      return null;
    }
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('token');
  }
};

export type { ApiResult };
